
// blulab, document ready
document.addEventListener("DOMContentLoaded", function () {


    // // https://swiperjs.com/swiper-api
    // // https://swiperjs.com/demos
    // const swiper = new Swiper('.swiper.blu-swiper-default', {
    //     // Optional parameters
    //     loop: true,
      
    //     // If we need pagination
    //     pagination: {
    //       el: '.swiper-pagination',
    //     },
      
    //     // Navigation arrows
    //     navigation: {
    //       nextEl: '.swiper-button-next',
    //       prevEl: '.swiper-button-prev',
    //     },
      
    //     // And if we need scrollbar
    //     scrollbar: {
    //       el: '.swiper-scrollbar',
    //     },

    //   });

    //   document.querySelectorAll('.swiper.blu-swiper-attr').forEach(swiperEl => {

    //     const spaceBetweenDefault = swiperEl.dataset.swiperSpaceBetween
    //       ? parseInt(swiperEl.dataset.swiperSpaceBetween)
    //       : 0;
      
    //     const spaceBetweenMobile = swiperEl.dataset.swiperSpaceBetweenMobile
    //       ? parseInt(swiperEl.dataset.swiperSpaceBetweenMobile)
    //       : spaceBetweenDefault;
      
    //     new Swiper(swiperEl, {
    //       autoplay: swiperEl.dataset.swiperAutoplay === "false"
    //         ? false
    //         : (swiperEl.dataset.swiperAutoplay
    //             ? { delay: parseInt(swiperEl.dataset.swiperAutoplay) }
    //             : false),
    //       loop: swiperEl.dataset.swiperLoop === "true",
    //       pagination: swiperEl.dataset.swiperPagination === "true"
    //         ? { el: ".swiper-pagination", clickable: true }
    //         : false,
    //       navigation: swiperEl.dataset.swiperNavigation === "true"
    //         ? { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }
    //         : false,
    //       scrollbar: swiperEl.dataset.swiperScrollbar === "true"
    //         ? { el: ".swiper-scrollbar", draggable: true }
    //         : false,
    //       effect: swiperEl.dataset.swiperEffect
    //         ? swiperEl.dataset.swiperEffect
    //         : "slide",
    //       fadeEffect:
    //         swiperEl.dataset.swiperEffect === "fade"
    //           ? { crossFade: true }
    //           : undefined,
    //       slidesPerView:
    //         swiperEl.dataset.swiperSlidesPerView === "auto"
    //           ? "auto"
    //           : (swiperEl.dataset.swiperSlidesPerView
    //               ? parseInt(swiperEl.dataset.swiperSlidesPerView)
    //               : 1),
    //       slidesPerGroup: swiperEl.dataset.swiperSlidesPerGroup
    //         ? parseInt(swiperEl.dataset.swiperSlidesPerGroup)
    //         : 1,
    //       spaceBetween: spaceBetweenDefault,
    //       breakpoints: {
    //         0: {
    //           spaceBetween: spaceBetweenMobile,
    //         },
    //         580: {
    //           spaceBetween: spaceBetweenDefault,
    //         },
    //       },
    //       freeMode: swiperEl.dataset.swiperFreemode === "true"
    //     });
      
    //   });
      



      // window.addEventListener('theme:cart:updated', (event) => {
      //   const cartCountElements = document.querySelectorAll('[data-cart-count]');
      //   const bluCartCountElements = document.querySelectorAll('[data-blu-cart-count]');
        
      //   // Ricavo il valore da uno qualunque dei [data-cart-count]
      //   const firstCartCountElement = cartCountElements[0];
      
      //   if (!firstCartCountElement) return;
      
      //   const cartCount = firstCartCountElement.dataset.cartCount || 0;
      
      //   // Aggiorna TUTTI i [data-cart-count]
      //   cartCountElements.forEach(el => {
      //     el.setAttribute('data-cart-count', cartCount);
      //   });
      
      //   // Aggiorna TUTTI i [data-blu-cart-count]
      //   bluCartCountElements.forEach(el => {
      //     el.setAttribute('data-blu-cart-count', cartCount);
      //   });
      // });
      
      
      



      // // blulab, desc collapse usato nelle collection
      // document.querySelectorAll('.js-desc-collapse').forEach(function (collapseBlock) {
      //   const button = collapseBlock.querySelector('.js-desc-collapse-toggle');
  
      //   if (button) {
      //     button.addEventListener('click', function (e) {
      //       e.preventDefault();
  
      //       // Stato attuale
      //       const isExpanded = collapseBlock.getAttribute('data-js-collapse-expanded') === 'true';
  
      //       // Inverti stato
      //       collapseBlock.setAttribute('data-js-collapse-expanded', String(!isExpanded));
  
      //       // Toggle classe facoltativa per stile
      //       collapseBlock.classList.toggle('is-expanded', !isExpanded);
  
      //       // Cambia testo bottone se presenti data-text-show/hide
      //       const showText = button.getAttribute('data-text-show');
      //       const hideText = button.getAttribute('data-text-hide');
      //       if (showText && hideText) {
      //         button.textContent = isExpanded ? showText : hideText;
      //       }
      //     });
      //   }
      // });
      

    // // blulab, popover
    // var popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');

    // popoverTriggerList.forEach(function (popoverTriggerEl) {

    //     // permetti html all'interno del popover
    //     var popover = new bootstrap.Popover(popoverTriggerEl, {
    //         html: true,
    //         sanitize: false
    //     });

    //     popoverTriggerEl.addEventListener("shown.bs.popover", function () {
    //         var popoverElement = document.querySelector(".popover"); // Seleziona il popover visibile
            
    //         // Chiude il popover quando si clicca sulla "X"
    //         popoverElement.querySelector(".close-popover").addEventListener("click", function () {
    //             popover.hide();
    //         });

    //         // Chiude il popover quando si clicca fuori, ma non se si clicca dentro
    //         document.addEventListener("click", function (event) {
    //             if (popoverElement && !popoverTriggerEl.contains(event.target) && !popoverElement.contains(event.target)) {
    //                 popover.hide();
    //             }
    //         }, { once: true }); // Esegui solo una volta per evitare più listener
    //     });
    // });


    // // blulab toast
    // document.querySelectorAll(".show-toast").forEach(button => {
    //     button.addEventListener("click", function () {
    //       let toastId = this.getAttribute("data-toast-id");
    //       let toastEl = document.getElementById(toastId);
    //       let toast = new bootstrap.Toast(toastEl);
    //       toast.show();
    //     });
    //   });


    // // blulab, tooltip
    // const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    // const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));



    // blulab link prevent default
    document.addEventListener('click', function(event) {
      // Verifica se l'elemento cliccato o uno dei suoi genitori ha la classe 'js-prevent-default'
      const target = event.target.closest('.js-prevent-default');

      if (target && target.tagName.toLowerCase() === 'a') {
        event.preventDefault();
        // console.log('Prevented default link behavior for:', target.href);
        // Puoi aggiungere qui il tuo codice custom
      }
    });


    // scroll to target
    // esempio <a href="#my-target" data-stt="true" data-stt-duration="600" data-stt-offtset="10"></a>
    document.querySelectorAll('[data-stt="true"]').forEach(trigger => {
      trigger.addEventListener("click", function (e) {
        const href = this.getAttribute("href");
        const dataTarget = this.getAttribute("data-stt-target");
        const rawTarget = (href && href.startsWith("#")) ? href.slice(1) : dataTarget;

        if (!rawTarget) return;

        const target = document.getElementById(rawTarget);
        if (!target) return;

        const offsetAttr = this.getAttribute("data-stt-offset");
        const offset = offsetAttr !== null && !isNaN(parseInt(offsetAttr)) ? parseInt(offsetAttr) : 0;

        const updateUrlAttr = this.getAttribute("data-stt-update-url");
        const updateURL = updateUrlAttr === "true"; // default: false

        e.preventDefault();
        e.stopImmediatePropagation();

        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top, behavior: 'smooth' });

        if (updateURL) {
          history.replaceState(null, null, `#${rawTarget}`);
        } else {
          history.replaceState(null, null, ' ');
        }
      }, true); // capturing
    });





});




// // Funzione per chiudere, tramite .blu-offcanvas-backdrop, 
// // l'.offcanvas immediatamente precedente e clicca il dismiss interno
// function clickDismissInPreviousOffcanvas(backdropEl) {
//   let previous = backdropEl.previousElementSibling;

//   // Cerca il primo elemento .offcanvas precedente nel DOM
//   while (previous && !previous.classList.contains('offcanvas')) {
//     previous = previous.previousElementSibling;
//   }

//   if (previous) {
//     // Cerca un bottone o link con attributo data-bs-dismiss="offcanvas"
//     const dismissBtn = previous.querySelector('[data-bs-dismiss="offcanvas"]');
//     if (dismissBtn) {
//       dismissBtn.click(); // Simula il click per chiusura nativa Bootstrap
//     }
//   }
// }

// // Delegazione eventi su tutto il documento
// document.addEventListener('click', function (e) {
//   const backdrop = e.target.closest('.blu-offcanvas-backdrop');
//   if (backdrop) {
//     clickDismissInPreviousOffcanvas(backdrop);
//   }
// });

// // MutationObserver per garantire il funzionamento anche con contenuti AJAX
// const observer = new MutationObserver(() => {
//   // Delegazione già attiva, quindi nessuna azione necessaria qui per ora
// });

// observer.observe(document.body, { childList: true, subtree: true });



// // blulab, gestione trigger button in predictive search + close button
// document.addEventListener('click', function (e) {
//   const root = e.target.closest('predictive-search-element');
//   if (!root) return;

//   // View all trigger -> View all button
//   const viewAllTrigger = e.target.closest('.blu-predictive-search-view-all-trigger-button');
//   if (viewAllTrigger) {
//     e.preventDefault();
//     const target = root.querySelector('.blu-predictive-search-view-all-button')
//               || document.querySelector('.blu-predictive-search-view-all-button');
//     if (target) target.click();
//     return;
//   }

//   // Close trigger -> Drawer close (stesso <predictive-search-element>)
//   const closeTrigger = e.target.closest('.blu-mm-close-trigger');
//   if (closeTrigger) {
//     e.preventDefault();
//     const drawerClose = root.querySelector('[data-drawer-close]');
//     if (drawerClose) drawerClose.click();
//     return;
//   }
// });





